export function readmore() {
  let news_pieces = document.querySelectorAll(".newsletters__piece");

  for (let i = 1; i <= news_pieces.length; i++) {
    $("#readmore-" + i).click(function () {
      $(".newsletters__piece-body-" + i).show("fast");

      $(this).addClass("hide");
      $("#readless-" + i).removeClass("hide");
    });
  }
}

export function readless() {
  let news_pieces = document.querySelectorAll(".newsletters__piece");

  for (let i = 1; i <= news_pieces.length; i++) {
    $("#readless-" + i).click(function () {
      $(this).addClass("hide");
      $(".newsletters__piece-body-" + i).hide("fast");
      $("#readmore-" + i).removeClass("hide");
    });
  }
}
